import Cartao from '@/components/ui/Cartao';
import Chip from '@/components/ui/Chip';
import EstadoVazio from '@/components/ui/EstadoVazio';
import type { OrigemFinanceira, ResumoFinanceiro } from './tipos';
import { chipOnde, reais, rotuloOrigem } from './rotulos';

function Mini({ rotulo, valor, forte = false }: { rotulo: string; valor: string; forte?: boolean }) {
  return (
    <span className="min-w-0">
      <span className="block text-[11px] text-foreground-400">{rotulo}</span>
      <span
        className={`block whitespace-nowrap tabular-nums text-[clamp(12px,3.6vw,13px)] ${
          forte ? 'font-bold text-foreground-950' : 'font-medium text-foreground-700'
        }`}
      >
        {valor}
      </span>
    </span>
  );
}

export default function BlocoDeOndeVeio({
  origens,
  resumo,
}: {
  origens: OrigemFinanceira[];
  resumo: ResumoFinanceiro;
}) {
  if (origens.length === 0) {
    return (
      <EstadoVazio
        icone="ri-line-chart-line"
        titulo="Nenhuma venda ainda"
        descricao="Quando entrar dinheiro no evento, aparece aqui de onde ele veio."
      />
    );
  }

  return (
    <Cartao className="p-4">
      <h2 className="text-[17px] font-bold text-foreground-950">De onde veio</h2>

      {/* Só a origem e onde o dinheiro está; os valores ficam no bloco de baixo. */}
      <ul className="mt-1 divide-y divide-secondary-100">
        {origens.map((o, i) => {
          const chip = chipOnde(o.onde);
          return (
            <li
              key={`${o.origem}-${o.onde}-${i}`}
              className="flex flex-wrap items-center gap-2 py-2.5"
            >
              <span className="text-[15px] font-semibold text-foreground-950">
                {rotuloOrigem(o.origem)}
              </span>
              <Chip tipo={chip.tipo}>{chip.rotulo}</Chip>
            </li>
          );
        })}
      </ul>

      <div className="mt-2 rounded-2xl bg-background-50 p-3">
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          <Mini rotulo="Vendido" valor={reais(resumo.vendido)} />
          <Mini rotulo="Se Liga" valor={reais(resumo.taxa_seliga)} />
          <Mini rotulo="Mercado Pago" valor={reais(resumo.taxa_mp)} />
          <Mini rotulo="Líquido" valor={reais(resumo.liquido)} forte />
        </div>
      </div>
    </Cartao>
  );
}